<template>
  <HCaptcha
    v-if="hcaptchaSiteKey"
    :site-key="hcaptchaSiteKey"
    @callback="emit('callback', $event)"
    @expired-callback="emit('expiredCallback')"
    @error-callback="emit('errorCallback', $event)"
    @load-error="emit('loadError')"
  />
  <Turnstile
    v-else
    @callback="emit('callback', $event)"
    @expired-callback="emit('expiredCallback')"
    @error-callback="emit('errorCallback', $event)"
    @load-error="emit('loadError')"
  />
</template>

<script setup lang="ts">
import { computed } from "vue";

import type { Newsletter } from "@/types/newsletter";

import HCaptcha from "./HCaptcha.vue";
import Turnstile from "./Turnstile.vue";

const props = defineProps<{
  newsletter: Newsletter;
}>();

const emit = defineEmits<{
  callback: [response: string];
  errorCallback: [response: string];
  expiredCallback: [];
  loadError: [];
}>();

const hcaptchaSiteKey = computed(() => {
  if (props.newsletter.captcha_provider !== "hcaptcha") return null;
  return props.newsletter.hcaptcha_site_key || null;
});
</script>
